/*
 * ─── Parallax Section System ────────────────────────────────────────────────
 *
 * Drives the translateY offset on every .parallax-section__bg element.
 * Uses a requestAnimationFrame loop gated by a scroll event flag (ticking)
 * so the rAF callback runs at most once per frame regardless of scroll speed.
 *
 * No external libraries. Works on iOS Safari (background-attachment: fixed
 * is broken there; we use JS transform instead).
 *
 * Respects prefers-reduced-motion: if the user has motion reduction enabled,
 * the script exits immediately and the bg stays static.
 *
 * Speed formula:
 *   offset = (0.5 - progress) * speed * viewportHeight
 *   where progress = 0 (section just visible at viewport bottom)
 *               → 1 (section just exited viewport top)
 *
 *   At progress 0.5 (section centred in viewport) offset = 0 (neutral).
 *   Default speed 0.5 → max travel ≈ ±25vh (well within the -30vh CSS buffer).
 *   Override per-section via CSS: --parallax-speed: 0.3;
 * ─────────────────────────────────────────────────────────────────────────── */

(function () {
  'use strict';

  // Respect user motion preference
  if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;

  var sections = Array.prototype.slice.call(
    document.querySelectorAll('.parallax-section')
  );
  if (!sections.length) return;

  var ticking = false;

  function updateParallax() {
    var viewH = window.innerHeight;

    sections.forEach(function (section) {
      var bg = section.querySelector('.parallax-section__bg');
      if (!bg) return;

      var rect     = section.getBoundingClientRect();
      var rawSpeed = getComputedStyle(section).getPropertyValue('--parallax-speed');
      var speed    = parseFloat(rawSpeed) || 0.5;

      // Skip sections completely outside the viewport
      if (rect.bottom < 0 || rect.top > viewH) return;

      // progress: 0 = section entering from bottom, 1 = section fully past top
      var progress = (viewH - rect.top) / (viewH + rect.height);
      var offset   = (0.5 - progress) * speed * viewH;

      bg.style.transform = 'translateY(' + offset.toFixed(1) + 'px)';
    });

    ticking = false;
  }

  function onScroll() {
    if (!ticking) {
      requestAnimationFrame(updateParallax);
      ticking = true;
    }
  }

  window.addEventListener('scroll', onScroll, { passive: true });
  window.addEventListener('resize', onScroll, { passive: true });

  // Set initial position before first scroll
  updateParallax();
})();
